import React from "react";
import styled from "@emotion/styled";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Divider as MuiDivider,
  Typography,
  Tabs,
  Tab,
  Box,
} from "@mui/material";
import { spacing } from "@mui/system";

import { sections } from "./docSections";

const Card = styled(MuiCard)(spacing);
const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

// A11y helpers for Tabs
function a11yProps(index: number) {
  return {
    id: `ohjeet-tab-${index}`,
    "aria-controls": `ohjeet-tabpanel-${index}`,
  } as const;
}

function TabPanel(props: {
  children?: React.ReactNode;
  index: number;
  value: number;
}) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`ohjeet-tabpanel-${index}`}
      aria-labelledby={`ohjeet-tab-${index}`}
      {...other}
    >
      {value === index && <Box pt={3}>{children}</Box>}
    </div>
  );
}

function SimpleTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Card mb={6}>
      <CardContent>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          aria-label="Ohjeet"
          sx={{ ml: -10 }}
        >
          {sections.map((s, i) => (
            <Tab key={s.label} label={s.label} {...a11yProps(i)} />
          ))}
        </Tabs>
        <Divider sx={{ mb: 2 }} />

        {sections.map((s, i) => (
          <TabPanel key={s.label} value={value} index={i}>
            {s.content}
          </TabPanel>
        ))}
      </CardContent>
    </Card>
  );
}

function Docs() {
  return (
    <React.Fragment>
      <Helmet title="Ohjeet" />
      <Typography variant="h3" gutterBottom display="inline">
        Ohjeet
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} to="/">
          Etusivu
        </Link>
        <Typography>Ohjeet</Typography>
      </Breadcrumbs>

      <Divider my={6} />

      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <SimpleTabs />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default Docs;
